import { TeamOutlined } from '@ant-design/icons'
import { useClickAway, useToggle } from 'ahooks'
import cls from 'classnames'
import { useAtom } from 'jotai'
import React from 'react'

import { DepartmentSearch } from '@/components'
import { departmentsTreeAtom } from '@/modules/department'

import s from './click-away.module.less'

export const ClickAwayDepartmentSearch: React.FC<{
  required: boolean
  name: string
  id: number
  readonly?: boolean
  isActive?: boolean
  wrapperClassName?: string | React.CSSProperties
  iconClassName?: string | React.CSSProperties
  textClassName?: string | React.CSSProperties
  searchComponentStyle?: React.CSSProperties
  onChange: (value: any, label: any, extra: any) => void
}> = ({
  name,
  id,
  required,
  isActive,
  iconClassName,
  wrapperClassName,
  textClassName,
  searchComponentStyle,
  readonly,
  onChange,
}) => {
  const [departments] = useAtom(departmentsTreeAtom)
  const [isShowingDropdown, { toggle: dropdownToggle }] = useToggle(false)
  const [isEditing, { toggle }] = useToggle(!!isActive)
  const ref = React.useRef<HTMLDivElement>(null)
  useClickAway(() => {
    if (!isShowingDropdown && !isActive) {
      toggle(false)
    }
  }, [ref])

  const hasDepartment = departments.some((d) => d.id === id)

  return (
    <div ref={ref} className={cls(wrapperClassName, 'flex')}>
      <TeamOutlined className={cls(iconClassName, 'mr-2 inline-flex items-center')} />
      {isEditing && !readonly ? (
        <DepartmentSearch
          allowClear={false}
          status={required && !id ? 'error' : undefined}
          dropdownMatchSelectWidth={false}
          onDropdownVisibleChange={(open) => dropdownToggle(open)}
          style={searchComponentStyle || { width: '100%' }}
          value={hasDepartment ? id : name || undefined}
          onChange={onChange}
        />
      ) : (
        <div
          className={cls(readonly ? '' : 'cursor-pointer', s.displayDepartment, textClassName || '')}
          onClick={(e) => {
            e.stopPropagation()
            toggle(true)
          }}
        >
          {name || '待确认'}
        </div>
      )}
    </div>
  )
}
